import { useQuery } from '~/hooks/useQuery';

import { ActivityApplicationEnum } from '../../../../types/interfaces/activity';

export const useLoadEcosystemApplicationsStatusReport = (
  ecosystem: string,
  activityDefinition?: string,
) => {
  const params: Partial<Record<'activityDefinitionId', string>> = {};

  if (activityDefinition) {
    params['activityDefinitionId'] = activityDefinition;
  }

  const { data, isLoading, isRefetching } = useQuery<{
    [key in ActivityApplicationEnum]: number;
  }>(`activity-application-insights/ecosystem/${ecosystem}/status/count`, {
    requestOptions: {
      params,
    },
    queryOptions: {
      enabled: !!ecosystem,
    },
    key: `ecosystem-activities-report-${ecosystem}-count-status-${activityDefinition}`,
  });

  return { data, isLoading, isRefetching };
};
